import Services from "../services/Services";
import DateHelper from "../helpers/DateHelper";


export default class Notificacao {
	pk;
	assunto;
	lida;
	mensagem;
	prazo;
	criadoEm;


	constructor({
		pk,
		assunto,
		lida,
		mensagem,
		prazo,
		criadoEm
	}) {
		this.pk = pk;
		this.assunto = assunto;
		this.lida = lida;
		this.mensagem = mensagem;
		this.prazo = prazo;
		this.criadoEm = criadoEm;
	}

	static async getNotificacoes(empresaPk, colaboradorPk, params) {
		const notificacaoResponse = await Services.NotificacaoService.notificacoes(
			empresaPk,
			colaboradorPk,
			params
		);

		if (notificacaoResponse.results) {
			return {
				notificacoes: Notificacao.fromListMap(notificacaoResponse.results),
				totalNotificacoes: notificacaoResponse.count
			};
		}

		return [];
	}

	static async marcarComoLida(empresaPk, colaboradorPk, notificacao) {
		await Services.NotificacaoService.editarNotificacao(
			empresaPk,
			colaboradorPk,
			notificacao.pk,
			{
				lida: notificacao.lida
			}
		);
	}

	static quantidadeNaolidas(notificacoes) {
		if (!notificacoes || !Array.isArray(notificacoes)) {
			return 0;
		}

		return notificacoes.filter(notificacao => {
			return !notificacao.lida;
		}).length;
	}

	static toFormData(notificacao) {
		if (!notificacao) return notificacao;

		notificacao = Notificacao.toMap(notificacao);


		const formData = {};

		Object.keys(notificacao).forEach(key => {
			switch (key) {

				// case "lida":
				// 	if (notificacao[key] != "true" && notificacao[key] != "false") return;
				// 	formData[key] = JSON.parse(notificacao[key]);
				// 	break;

				default:
					if (
						notificacao[key] === null ||
						notificacao[key] === undefined ||
						notificacao[key] === ""
					)
						return;
					formData[key] = notificacao[key];
					break;
			}
		});

		return formData;
	}

	static toMap(notificacao) {
		notificacao = {
			...notificacao,
			created_at: notificacao.criadoEm,
		};

		delete notificacao.criadoEm;

		return notificacao;
	}

	static fromMap(map) {
		if (!map) {
			return map;
		}

		Object.keys(map).forEach(key => {
			if (map[key] === null || map[key] === undefined) {
				delete map[key];
			}
		});

		let criadoEm = DateHelper.toDate(map.created_at);

		return new Notificacao({
			...map,
			criadoEm,
		});
	}

	static fromListMap(mapList) {
		return mapList.map(map => {
			return Notificacao.fromMap(map);
		});
	}
}
